// 组件
import importImg from '@/components/importImg.vue'
import alterForm from '@/components/alterForm'
// 接口
import { getShopList, getShopAdminUsersList, getGlobalLabelList, postShopsFormData } from '@/services/store.js'
// 其他
import loading from '@/utils/loading.json'
import jsonData from './jsonData'
import constant from '@/utils/constant.js'

export default {
  components: {
    importImg,
    alterForm
  },
  data () {
    return {
      collapseLength: [],
      formData: jsonData.formData
    }
  },
  watch: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      this.collapseLength = [...new Array(this.formData.length).keys()]
      this.$store.state.app.loading = this.$loading(loading)
      getShopAdminUsersList().then(res => {
        if (res.status === 200) {
          this.formData[0].createDateItem[7].options = res.data.admin_users
        }
      })
      getShopList().then(res => {
        if (res.status === 200) {
          this.formData[0].createDateItem[10].options = res.data.collections.item_types
          this.formData[1].createDateItem[1].options = res.data.collections.display_types
          this.formData[1].createDateItem[2].options = res.data.collections.shop_category_item_sorting_methods
          this.formData[1].createDateItem[3].options = res.data.collections.tag_choices
          // this.formData[2].createDateItem[1].options = res.data.collections.theme_modes
          this.formData[2].createDateItem[13].options = res.data.collections.third_party_delivery_services
          this.formData[2].createDateItem[3].options = res.data.collections.pick_up_display_mode_options
          this.formData[3].createDateItem[3].options = res.data.collections.pick_up_display_mode_options
          this.formData[2].createDateItem[10].options = res.data.collections.express_fee_mode_options
          this.formData[5].createDateItem[0].options = res.data.collections.paynow_type_options
          this.formData[5].createDateItem[4].options = res.data.collections.stripe_type_options
          this.formData[2].createDateItem[7].createDateFirstItem[5].options = res.data.collections.weekdays
          this.formData[4].createDateItem[3].options = res.data.collections.third_party_delivery_services
        }
      })
      getGlobalLabelList().then(res => {
        if (res.status === 200) {
          this.formData[0].createDateItem[21].options = res.data.global_labels
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    },
    formSubmit (data) {
      this.$store.state.app.loading = this.$loading(loading)
      const obj = JSON.parse(JSON.stringify(data))
      const params = {
        shop: obj
      }
      params.shop.remote_logo_url = params.shop.logo
      params.shop.remote_paynow_qrcode_url = params.shop.paynow_qrcode
      delete params.shop.logo
      delete params.shop.paynow_qrcode
      Object.keys(params.shop).forEach(res => {
        if (typeof params.shop[res] === 'boolean') {
          if (params.shop[res] === true) params.shop[res] = '1'
          if (params.shop[res] === false) params.shop[res] = '0'
        }
      })
      postShopsFormData(params).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: this.$t('message.operateSuccess')
          })
          setTimeout(() => {
            this.$router.push({
              name: 'shopsManagerList'
            })
          }, constant.ROUTER_CHANGE_INTERVAL)
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    }
  }
}
